import * as React from 'react';
import { Button } from '@cian/ui-kit';

import * as styles from './DobroListingPopupFooter.css';

export interface IDobroListingPopupFooterProps {
  isMobile: boolean;
  onSaveClick: () => void;
  onCopyClick: () => void;
}

export function DobroListingPopupFooter(props: IDobroListingPopupFooterProps) {
  const { isMobile, onSaveClick, onCopyClick } = props;

  return (
    <div className={styles.buttons}>
      <Button fullWidth={isMobile} onClick={onSaveClick} size="L">
        Сохранить
      </Button>
      <Button
        fullWidth={isMobile}
        onClick={onCopyClick}
        theme={isMobile ? 'fill_secondary' : 'fill_white_primary'}
        size="L"
      >
        Копировать
      </Button>
    </div>
  );
}
